import { Chip, Stack, Tooltip, useTheme } from '@mui/material';

interface Props {
  tagData: Array<{ name: string; color: string }>;
}

const StatusTooltipChips = ({ tagData }: Props) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
      gap={0.5}
    >
      {tagData?.map((tag, index) => (
        <Tooltip key={index} title={tag?.name} arrow placement="top">
          <Chip
            style={{
              backgroundColor: tag?.color,
              color: theme.palette.common.white,
              height: '8px',
              width: '35px',
              lineHeight: '20px',
            }}
          />
        </Tooltip>
      ))}
    </Stack>
  );
};

export default StatusTooltipChips;
